import axios from 'axios'
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL

// ✅ Fetch greeting message
export const fetchGreetingMessage = async (botId) => {
    try {
        const response = await axios.get(`${API_URL}/customizeBotGreetingMessage/${botId}`)
        return response.data.greetingMessage // assuming response includes { greetingMessage: "..." }
    } catch (error) {
        console.error('Error fetching welcome message:', error)
        throw error
    }
}

// ✅ Create or update welcome message
export const createOrUpdateGreetingMessage = async (botId, greetingMessage) => {
    try {
        const response = await axios.post(`${API_URL}/customizeBotGreetingMessage/${botId}`, {
            greetingMessage,
        })
        if (response.status === 200) {
            Swal.fire({
                icon: 'success',
                title: 'Welcome Message Saved',
                showConfirmButton: false,
                timer: 1500,
            })
        }
        return response.data
    } catch (error) {
        console.error('Error saving welcome message:', error)
        Swal.fire({
            icon: 'error',
            title: 'Failed to save welcome message',
        })
        throw error
    }
}
